import { render, staticRenderFns } from "./OrderTableComponent.vue?vue&type=template&id=61e62fa7&"
import script from "./OrderTableComponent.vue?vue&type=script&lang=js&"
export * from "./OrderTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports